const ANNOTATION_DEBUG_QUERY_PARAM = 'annotationDebug'
const ANNOTATION_DEBUG_STORAGE_KEY = 'forecast.annotationDebug'

const isAnnotationDebugEnabled = () => {
  if (typeof window === 'undefined') {
    return false
  }

  const queryParams = new URLSearchParams(window.location.search)
  if (queryParams.get(ANNOTATION_DEBUG_QUERY_PARAM) === 'true') {
    return true
  }

  try {
    return window.localStorage.getItem(ANNOTATION_DEBUG_STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

export const logAnnotationDebug = (
  eventName: string,
  payload?: Record<string, unknown>
) => {
  if (!isAnnotationDebugEnabled()) {
    return
  }

  // eslint-disable-next-line no-console
  console.debug(`[annotation-debug] ${eventName}`, payload ?? {})
}
